import { getIsGoodRoad, goodRoadsSliceActions } from '@/modules/goodRoad/slice';
import { getHostById } from '@/modules/host/slice';
import store from '@/store/store';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { convertIsGoodRoad } from '../../../utils/games/baccarat';
import { CMDSpBaccaratGoodRoad, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpBaccaratGoodRoadHandler extends AbstractHandler {
    _command: CMDSpBaccaratGoodRoad;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBaccaratGoodRoad;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsRest } = getHostById(state, this._command.HostID);
        const isGoodRoad = convertIsGoodRoad(this._command);
        const goodRoad = getIsGoodRoad(state, this._command.HostID);
        if (goodRoad && goodRoad.isGoodRoad !== isGoodRoad) {
            dispatch(
                goodRoadsSliceActions.update({
                    HostId: this._command.HostID,
                    isGoodRoad: isGoodRoad,
                    isRest: IsRest,
                })
            );
        }
    }
}
